'use strict';

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var core_Icon_icons_default_Warning = require('./core/Icon/icons/default/Warning.js');
var core_Icon_icons_default_Tick = require('./core/Icon/icons/default/Tick.js');
var Paragraph = require('./Paragraph-284fa117.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject$3, _templateObject2$1;
styled__default["default"].input(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral__default["default"](["\n    --inputTextColorDisabled: ", ";\n    --inputBorderBottomWidth: 2px;\n\n    background: ", ";\n    border: none;\n    border-bottom: var(--inputBorderBottomWidth) solid transparent;\n    border-radius: ", ";\n    box-sizing: border-box;\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    outline: none;\n    padding-bottom: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    padding-top: ", ";\n    width: 100%;\n\n    &::placeholder {\n        color: ", ";\n        opacity: 1;\n    }\n\n    &:disabled {\n        color: var(--inputTextColorDisabled);\n\n        &::placeholder {\n            color: var(--inputTextColorDisabled);\n        }\n    }\n\n    &:read-only {\n        color: var(--inputTextColorDisabled);\n    }\n\n    &:focus {\n        border-bottom-color: ", ";\n        border-radius: ", ";\n    }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['text-global-disabled'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['background-global-secondary'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['text-global-primary'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fonts.family;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.p2.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return "calc(".concat(theme.space[14], " - var(--inputBorderBottomWidth))");
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space[16];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space[16];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.space[14];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors['text-global-secondary'];
}, function (_ref12) {
  var theme = _ref12.theme,
    hasError = _ref12.hasError;
  return hasError ? theme.colors['borders-global-error'] : theme.colors['background-brand-primary'];
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.radii.medium, " ").concat(theme.radii.medium, " 0 0 ");
});
var InputWrapper = styled__default["default"].div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral__default["default"](["\n    box-sizing: border-box;\n    display: ", ";\n    position: relative;\n    width: inherit;\n\n    & svg {\n        color: ", ";\n    }\n"])), function (_ref14) {
  var _ref14$fullWidth = _ref14.fullWidth,
    fullWidth = _ref14$fullWidth === void 0 ? false : _ref14$fullWidth;
  return fullWidth ? 'block' : 'inline-block';
}, function (_ref15) {
  var theme = _ref15.theme,
    disabled = _ref15.disabled;
  return disabled ? theme.colors['text-global-disabled'] : theme.colors['icon-global-primary'];
});

var _templateObject$2, _templateObject2;
var ErrorIcon = styled__default["default"](core_Icon_icons_default_Warning["default"])(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colors['icon-global-error'], " !important");
});
var FilledIcon = styled__default["default"](core_Icon_icons_default_Tick["default"])(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.colors['icon-global-highlight'], " !important");
});

var _templateObject$1;
var AffixWrapper = styled__default["default"].div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral__default["default"](["\n    --textColor: ", ";\n    --iconColor: ", ";\n\n    color: var(--textColor);\n\n    & svg {\n        color: var(--iconColor);\n        display: block;\n    }\n\n    &[data-affix-disabled='true'] {\n        --textColor: ", ";\n        --iconColor: ", ";\n    }\n\n    & .n-affix-text {\n        color: inherit;\n    }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['text-global-secondary'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['icon-global-primary'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['text-global-disabled'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['icon-global-disabled'];
});

var _templateObject;
var SymbolsCounterStyled = styled__default["default"](Paragraph.P4)(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    color: ", ";\n    text-align: right;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['text-global-secondary'];
});

exports.AffixWrapper = AffixWrapper;
exports.ErrorIcon = ErrorIcon;
exports.FilledIcon = FilledIcon;
exports.InputWrapper = InputWrapper;
exports.SymbolsCounterStyled = SymbolsCounterStyled;
//# sourceMappingURL=SymbolsCounter.style-64b0606b.js.map
